// The SFU decides what a LiveKit participant identity looks like: the
// anonymised SHA-256 for sticky-event RTC memberships, or `user:device` on the
// legacy path. Index every candidate so either shape resolves.
export const buildRtcIdentityMap = (members) => {
    const identities = new Map();
    members.forEach((member) => {
        const { userId, deviceId } = member;
        if (!userId)
            return;
        [member.rtcBackendIdentity, member.memberId, deviceId && `${userId}:${deviceId}`].forEach((candidate) => {
            if (candidate)
                identities.set(candidate, userId);
        });
    });
    return identities;
};
//# sourceMappingURL=livekitCallIdentity.js.map